import {IToJson} from '@toolify/client/src/types/IToJson'
import {IGetWorkspaceUsageRequestInterfaces} from '@toolify/server/src/controllers/WorkspaceController/validators/GetUsage/types/IGetWorkspaceUsageRequestInterfaces'
import {mapResponseEntity} from './mapResponseEntity'

type TUsageResponse = IGetWorkspaceUsageRequestInterfaces['response']

export function mapWorkspaceUsageResponse(
  data: IToJson<TUsageResponse>,
): TUsageResponse {
  return {
    ...data,
    uniqueEntities: data.uniqueEntities.map((row) => ({
      ...row,
      entity: mapResponseEntity(row.entity),
    })),
  }
}
